import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import moment from 'moment';
import Common from '../Common/common';

const Usermaster = (props) => {
  const { user, settings } = props;
  const [userData, setUserData] = useState(null);
  const [userNew, setUserNew] = useState({ user_id: '', user_class: constClass.CLASS.SHOP, shop_id: 0, user_name: '', user_short: '', password: '', upd_date: null });
  const [lockData, setLockData] = useState(false);
  const [errCheckMsg, setErrCheckMsg] = useState({});
  const { addToast } = useToasts();

  const refreshUser = useCallback(async () => {
    setUserData(null);
    const jwt = localStorage.getItem('jwt');
    const reg_params = {
      "site_id": props.match.params.siteId,
      "operator": "and",
      "where": [{ "site_id": props.match.params.siteId }]
    }
    // userデータ取得
    var data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/search/${props.match.params.siteId}`, reg_params, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    // 新規ユーザ初期化
    const new_data = { user_id: '', user_class: constClass.CLASS.SHOP, user_name: '', user_short: '', password: '',  upd_date: null,  updflg: false };
    setUserNew(new_data);
    
    data.sort((a, b) => a.shop_id !== b.shop_id ? a.shop_id - b.shop_id : a.user_id > b.user_id ? 1 : -1);
    setUserData(data);
    // エラーメッセージ初期化
    setErrCheckMsg({});
  }, [props.match.params.siteId])

  // 登録ボタン：処理
  const handleUserRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!data.user_name) {
      window.alert('ユーザ名を入力してください。');
      return;
    }
    if(data.user_id && !(data.user_id.length <= 20)){
      window.alert('ユーザIDは20文字以内で入力してください');
      return;
    }
    if (!(String(data.password)).match(/^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[0-9a-zA-Z]{8,20})$/)) {
      window.alert('パスワードは[半角英字(大文字)][半角英字(小文字)][半角数字]の3種類を含む、8文字以上・20文字以下で入力してください。');
      return;
    }
    if(data.user_name && !(data.user_name.length <= 50)){
      window.alert('ユーザ名は50文字以内で入力してください');
      return;
    }
    if (data.user_id && data.user_id.trim().match(/\s+/g)) {
      window.alert('ユーザIDに空白文字は使用できません。');
      return;
    }
    if (data.password && data.password.match(/\s+/g)) {
      window.alert('パスワードに空白文字は使用できません。');
      return;
    }
    if(data.password && data.password.match(/[^a-zA-Z0-9\-/:;()\\&@".,?!'[\]{}#%^*+=_|~<>$`€£•]+/g)){
      window.alert('パスワードは半角英数記号で入力してください');
      return;
    }
    //(data.password && data.password.match(/\s+/g))
    const params = {
      site_id: props.match.params.siteId,
      user_id: data.user_id.trim(),
      user_class: data.user_class,
      user_name: data.user_name,
      user_short: data.user_short,
      password: data.password ? data.password : null,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/user`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshUser();
      }
      setLockData(false);
    }
  }

  // 削除ボタン：処理
  const handleUserDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!window.confirm(`ユーザ[${data.user_id}:${data.user_name}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: props.match.params.siteId,
      user_id: data.user_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshUser();
      }
      setLockData(false);
    }
  }

  // 削除ボタン：処理
  const handleUserUnlockClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    const params = {
      site_id: props.match.params.siteId,
      user_id: data.user_id
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/unlock/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
      addToast('ロックを解除しました。', { appearance: 'success', autoDismiss: true });
      await refreshUser();
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      }
      setLockData(false);
    }

  }

  // 削除ボタン：処理
  const handleUserMfaClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!window.confirm(`ユーザ[${data.user_id}:${data.user_name}]の二要素認証(MFA)を削除します。\n次回ログイン時にアプリの登録が必要です。\n削除してもよろしいですか？`)) {
      return;
    }
    const params = {
      site_id: props.match.params.siteId,
      user_id: data.user_id
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/mfa/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
      addToast('MFA登録を削除しました。', { appearance: 'success', autoDismiss: true });
      await refreshUser();
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } 
      setLockData(false);
    }

  }

  // value値変更イベント
  const handleChangeCell = (index, key) => (event) => {
    if (index === 'new') {
      const new_data = { ...userNew, [key]: event.target.value };
      setUserNew(new_data);
    } else {
      const _userData = [...userData];
      _userData[index] = { ..._userData[index], [key]: event.target.value };
      setUserData(_userData);
    }
  }

  // 登録ボタン
  const renderRegistButton = (data, idx) => {
    return (
      <button type="button"
        disabled={lockData || !!errCheckMsg[idx]}
        className={`btn btn-primary mx-1 text-nowrap`}
        onClick={() => handleUserRegistClick(data)}>
        登録
      </button>
    )
  }

  // 削除ボタン
  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.user_id === null}
        className={`btn btn-primary mx-1 text-nowrap`}
        onClick={() => handleUserDeleteClick(data)}>
        削除
      </button>
    )
  }

  // ロック解除ボタン
  const renderUnlockButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.time_id === null}
        className={`btn btn-primary mx-1`}
        onClick={() => handleUserUnlockClick(data)}>
        ロック解除
      </button>
    )
  }

  // MFA削除ボタン
  const renderMfaButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.time_id === null}
        className={`btn btn-secondary mx-1`}
        onClick={() => handleUserMfaClick(data)}>
        MFA登録削除
      </button>
    )
  }

  // 初期実行トリガー
  useEffect(() => {
    async function fetchData() {
      await refreshUser();
    }
    return fetchData();
  }, [refreshUser]);

  return (
    <div className="container">
      {userData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {userData !== null && (
        <div className="row mb-3 p-0">
          <div className="col-12 p-0">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <td className="text-center">
                      ユーザID
                  </td>
                  <td className="text-center">
                      パスワード
                  </td>
                  <td className="text-center">
                      ユーザ区分
                  </td>
                  <td className="text-center">
                      ユーザ名
                  </td>
                  <td className="text-center">
                    更新日時
                  </td>
                  <td className="text-center">
                    処理
                  </td>
                </tr>
              </thead>
              <tbody>
                {/* 新規入力行 管理者のみ表示 */}
                {(user.userClass === constClass.CLASS.ADMIN) &&
                  <tr key="new">
                    {/* ユーザID */}
                    <td className="text-center align-middle">
                      <input type="text" className="form-control" id={"user_id_new"} name="user_id[]" value={userNew.user_id} onChange={handleChangeCell('new', 'user_id')} size="15"></input>
                    </td>
                    {/* パスワード */}
                    <td className="text-center align-middle">
                      <input type="text" className="form-control" id={"password_new"} name="password[]" value={userNew.password} onChange={handleChangeCell('new', 'password')} size="15"></input>
                    </td>
                    {/* ユーザ区分 */}
                    <td className="text-center align-middle">
                      <select className="form-control" name="user_class[]" id={"user_class_new"} value={userNew.user_class} onChange={handleChangeCell('new', 'user_class')}>
                        <option value={constClass.CLASS.SHOP}>{constClass.CLASS_NAME.SHOP}</option>
                        <option value={constClass.CLASS.ADMIN}>{constClass.CLASS_NAME.ADMIN}</option>
                      </select>
                    </td>
                    {/* ユーザ名 */}
                    <td className="text-center align-middle">
                      <input type="text" className="form-control" id={"user_name_new"} name="user_name[]" value={userNew.user_name} onChange={handleChangeCell('new', 'user_name')}></input>
                    </td>
                    {/* 更新日時 */}
                    <td className="text-center align-middle">
                    </td>
                    {/* 処理 */}
                    <td className="text-center align-middle">
                      {renderRegistButton(userNew, 'new')}
                    </td>
                  </tr>
                }
                {userData.map((data, idx) => (
                  <tr key={idx}>
                    {/* ユーザID */}
                    <td className="text-center align-middle">
                      {data.user_id}
                    </td>
                    {/* パスワード */}
                    <td className="text-center align-middle">
                      <input type="text" className="form-control" id={"password" + idx} name="password[]" value={data.password} onChange={handleChangeCell(idx, 'password')} size="15"></input>
                    </td>
                    {/* ユーザ区分 */}
                    <td className="text-center align-middle">
                      <select className="form-control" name="user_class[]" id={"user_class" + idx} value={data.user_class} onChange={handleChangeCell(idx, 'user_class')} disabled={user.userClass !== constClass.CLASS.ADMIN}>
                        <option value={constClass.CLASS.SHOP}>{constClass.CLASS_NAME.SHOP}</option>
                        <option value={constClass.CLASS.ADMIN}>{constClass.CLASS_NAME.ADMIN}</option>
                      </select>
                    </td>
                    {/* ユーザ名 */}
                    <td className="text-center align-middle">
                      <input type="text" className="form-control" id={"user_name" + idx} name="user_name[]" value={data.user_name} onChange={handleChangeCell(idx, 'user_name')} disabled={user.userClass !== constClass.CLASS.ADMIN}></input>
                    </td>
                    {/* 更新日時 */}
                    <td className="text-center align-middle">
                      {data.upd_date ? moment(data.upd_date).format('YYYY-MM-DD HH:mm:ss') : ''}
                    </td>
                    {/* 処理 */}
                    <td className="text-center align-middle">
                      {renderRegistButton(data, idx)}
                      {(data.user_id !== user.userId) && renderDeleteButton(data)}
                      {(user.userClass === constClass.CLASS.ADMIN && Common.getSettingValue(settings, 'LOGIN_FAIL_COUNT', '') && data.fail_count >= Number(Common.getSettingValue(settings, 'LOGIN_FAIL_COUNT', ''))) && renderUnlockButton(data)}
                      {(user.userClass === constClass.CLASS.ADMIN && Common.getSettingValue(settings, 'MFA_USE', '0') === constClass.FLAG.ON && data.secret_count >= 1) && renderMfaButton(data)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}

export default Usermaster;